import { z } from 'zod';

import { MaintenanceChecklistCategoryInputSchema } from './maintenance-checklist.schemas.js';

/** Full replacement of name and composition (BR-PRD-153/154). */
export const UpdateMaintenanceChecklistBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  categories: z.array(MaintenanceChecklistCategoryInputSchema),
});

export const UpdateMaintenanceChecklistResponseSchema = z.object({
  maintenanceChecklistId: z.uuid(),
});

export type UpdateMaintenanceChecklistBody = z.infer<typeof UpdateMaintenanceChecklistBodySchema>;
export type UpdateMaintenanceChecklistResponse = z.infer<
  typeof UpdateMaintenanceChecklistResponseSchema
>;
